import React from 'react';
import logo from './logo.svg';
import './App.css';

import FlightsForm from './components/FlightsForm';

function App() {
  return (
    <div className="App">
      <header className="navbar-header bg-primary">
        <div className="row">
          <div className="col align-self-center">
            <h1>
              <a className="text-light text-decoration-none" href="/">Onward Flight Ticket</a>
            </h1>
            <div className="row">
              <div className="col">
                <h4 className="text-light">Dummy Ticket - For free!</h4>
              </div>
            </div>
          </div>
        </div>
      </header>
      <FlightsForm/>

      <footer className="page-footer font-small yellow">
        <div className="footer-copyright text-center py-3">© 2023 Copyright:
          <div className="row justify-content-center">
            <div className="col">
              <a href="/">
                onwardflightticket.com
              </a>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p>For any requests contact: <a href="mailto:onwardflightticket@gmail.com">onwardflightticket@gmail.com</a></p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
